import { useAppTheme } from "core/contexts/theme/theme";
import { Prompt, Form } from "../../chat.type";

interface SuggestedPromptsProps {
  modelSuggestedPrompts: Prompt[];
  setActiveForm: (form: Form | null) => void;
  setModelSuggestedPrompt: (prompt: string | null) => void;
}

export function SuggestedPrompts({
  modelSuggestedPrompts,
  setActiveForm,
  setModelSuggestedPrompt,
}: SuggestedPromptsProps) {
  const { apptheme } = useAppTheme();
  const isDarkTheme = apptheme?.name === "dark-theme";
  const bgColor = isDarkTheme ? "bg-[linear-gradient(110deg,#212121,45%,#27272a,55%,#212121)] bg-[length:200%_100%]" 
  : "bg-[linear-gradient(110deg,#ffffff,45%,#f1f5f9,55%,#ffffff)] bg-[length:200%_100%]"
  return (
    <div
      className={`${
        modelSuggestedPrompts.length > 0
          ? "flex flex-wrap justify-center pt-3 pb-3 gap-2 align-self-center"
          : ""
      }`}
    >
      {modelSuggestedPrompts.map(({ button, prompt, form }) => (
        <button
          key={button}
          onClick={() => {
            if (form) {
              setActiveForm(form);
            } else if (prompt) {
              setModelSuggestedPrompt(prompt);
            }
          }}
          className={`inline-flex flex-col items-center justify-center rounded-md border border-slate-700 
            ${bgColor} p-2 text-[0.65rem] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2
            ${isDarkTheme ? "text-white" : "text-black"}`}
        >
          {button}
        </button>
      ))}
    </div>
  );
}
